import styled from 'styled-components';

export const AchievementBadgeWrapper = styled.div`
  display: flex;
  align-items: center;
`;
